module.exports = __webpack_public_path__ + "img/7.823d400e.png";